import { BoxBlue100 } from '@box/blueprint-web-assets/tokens/tokens';
import get from 'lodash/get';
import React, { useCallback } from 'react';
import UploadsManager from 'box-ui-elements/es/elements/content-uploader/UploadsManager';
import OverallUploadsProgressBar from 'box-ui-elements/es/elements/content-uploader/OverallUploadsProgressBar';
import { LoadingIndicator } from '@box/blueprint-web';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { VIEW_UPLOAD_IN_PROGRESS } from 'box-ui-elements/es/constants';
import noop from 'lodash/noop';
import {
  FORM_SUBMITTER_ACTIONS,
  useFormSubmitterContext,
} from '../form-submitter-context';
import css from './form-upload-manager-with-context.module.scss';
import messages from './message';

const ProcessingUI = injectIntl(({ color, intl }) => {
  const OVERALL_PERCENTAGE = 99;
  const isBoxBlue = `#${color}`.toLowerCase() === BoxBlue100;
  return (
    <div
      className={classNames(
        'be bcu-uploads-manager-container bcu-is-expanded bcu-is-visible',
        css.processContainer,
      )}
    >
      <OverallUploadsProgressBar
        hasMultipleFailedUploads={false}
        isDragging={false}
        isExpanded
        isResumeVisible={false}
        isVisible
        onClick={noop}
        onKeyDown={noop}
        onUploadsManagerActionClick={noop}
        percent={OVERALL_PERCENTAGE}
        view={VIEW_UPLOAD_IN_PROGRESS}
      />
      <div className={css.processingInfo}>
        <div className={css.loading}>
          <LoadingIndicator
            // @ts-expect-error [MIGRATION-SUPPRESSION]: TS18048
            aria-label={intl.formatMessage(messages.loadingIndicatorAriaLabel)}
            className={css.crawler}
            variant={isBoxBlue ? 'default' : 'dark'}
          />
        </div>
        <p className={css.title}>
          <FormattedMessage {...messages.processingFilesTitle} />
        </p>
        <p className={css.message}>
          <FormattedMessage {...messages.processingFilesMessage} />
        </p>
      </div>
    </div>
  );
});

const FormUploadManagerWithContext = () => {
  const {
    state,
    dispatch,
    selector: { getAllItemsInUploadQueue },
  } = useFormSubmitterContext();
  const {
    uploader,
    isUploadManagerExpanded,
    isResumableUploadsEnabled,
    isUploadsManagerVisible,
    processingInProgress,
    form,
  } = state;
  const toggleUploadsManager = useCallback(() => {
    dispatch({
      type: FORM_SUBMITTER_ACTIONS.TOGGLE_UPLOAD_MANAGER,
    });
  }, [dispatch]);
  if (isUploadsManagerVisible) {
    const items = getAllItemsInUploadQueue(state);
    const color = get(form, 'content.theme.colors.primary.value', '');

    return (
      <div className={css.formUploadsManager}>
        {processingInProgress ? (
          <ProcessingUI color={color} />
        ) : (
          <UploadsManager
            isDragging={false}
            isExpanded={isUploadManagerExpanded}
            isResumableUploadsEnabled={isResumableUploadsEnabled}
            isVisible={isUploadsManagerVisible}
            items={items}
            onItemActionClick={uploader?.onRetryErrorItem}
            onRemoveActionClick={() => {}}
            onUploadsManagerActionClick={uploader?.onRetryAllErrorItems}
            toggleUploadsManager={toggleUploadsManager}
            view={VIEW_UPLOAD_IN_PROGRESS}
          />
        )}
      </div>
    );
  }
  return null;
};

export { FormUploadManagerWithContext, ProcessingUI };
export default FormUploadManagerWithContext;
